import { all, call, put, takeLatest } from "redux-saga/effects";
import { http } from "../../common/lib";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

function* patch(action) {
    const { auditImage } = action.payload;
    const url = `${config.api.paths.auditImages}${auditImage.id}/`;
    try {
        const { data } = yield call(
            http.authorized.patch,
            //config.api.paths.auditImages,
            url,
            auditImage
        );
        yield put(actionCreators.patchSuccess(data));
    } catch (error) {
        logToSentry("On audit image rotation patch:", { error });
        console.error(error);
        yield put(actionCreators.patchFailure(error));
    }
}

function* post(action) {
    const { auditImage } = action.payload;

    try {
        const { data } = yield call(
            http.authorized.post,
            config.api.paths.rotateImage,
            auditImage
        );

        yield put(actionCreators.postSuccess(data));
    } catch (error) {
        logToSentry("On audit image rotation patch:", { error });
        console.error(error);
        yield put(actionCreators.patchFailure(error));
    }
}

export default function* () {
    yield all([
        takeLatest(actionTypes.AUDIT_IMAGE_ROTATION_PATCH_REQUEST, patch),
        takeLatest(actionTypes.AUDIT_IMAGE_ROTATION_POST_REQUEST, post)
    ]);
}
